export default __webpack_public_path__ + "static/media/header-message.d1f5091f.svg";